import { render } from "./componentButton.vue?vue&type=template&id=97470c28"
import script from "./componentButton.vue?vue&type=script&lang=js"
export * from "./componentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__